const L = ["0001101", "0011001", "0010011", "0111101", "0100011", "0110001", "0101111", "0111011", "0110111", "0001011"];
const G = L.map((c) => c.split("").reverse().map((b) => (b === "1" ? "0" : "1")).join(""));
const R = L.map((c) => c.split("").map((b) => (b === "1" ? "0" : "1")).join(""));
const PAR = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];

export function ean13(value) {
  const d = String(value || "").replace(/\D/g, "");
  if (d.length !== 12 && d.length !== 13) return null;
  const n = d.slice(0, 12).split("").map(Number);
  const chk = (10 - (n.reduce((s, x, i) => s + x * (i % 2 ? 3 : 1), 0) % 10)) % 10;
  if (d.length === 13 && Number(d[12]) !== chk) return null;
  const all = [...n, chk];
  let bits = "101";
  for (let i = 1; i <= 6; i++) bits += (PAR[all[0]][i - 1] === "L" ? L : G)[all[i]];
  bits += "01010";
  for (let i = 7; i <= 12; i++) bits += R[all[i]];
  return { bits: bits + "101", digits: all.join("") };
}

export function Barcode({ value, className = "" }) {
  const e = ean13(value);
  if (!e) return <div className={`text-[9px] text-red-600 ${className}`}>Geçersiz ISBN</div>;
  return (
    <svg viewBox={`0 0 ${e.bits.length + 8} 34`} className={className} data-testid="cover-barcode">
      <rect width="100%" height="100%" fill="#fff" />
      {e.bits.split("").map((b, i) => b === "1" && <rect key={i} x={i + 4} y={2} width={1} height={24} fill="#000" />)}
      <text x="50%" y="32.5" textAnchor="middle" fontSize="6" fontFamily="monospace">{e.digits}</text>
    </svg>
  );
}
